<template>
  <div class="full_height">
    <el-button icon="el-icon-d-arrow-left" circle @click="backToLeftCom" class="returnCls"></el-button>
    <component v-if="currentCom" :is="currentCom" ref="com" :conditions="conditions"></component>
  </div>
</template>

<script>
export default {
  props: ["conditions", "com"],

  data() {
    return {
      currentCom: ""
    };
  },

  mounted() {
    this.currentCom = this.requireComponents(this.com);
  },

  methods: {
    requireComponents(com) {
      const component = resolve =>
        require([
          `@/views/silkRoadV2Data/components/mobile/comRight/${com}`
        ], resolve);
      return component;
    },

    backToLeftCom() {
      this.$emit("changeLeftStatus");
    }
  },

  watch: {
    com(newValue) {
      this.currentCom = this.requireComponents(newValue);
    }
  }
};
</script>

<style scoped>
.returnCls {
  position: absolute;
  right: 10px;
  z-index: 1000000;
  top: 5px;
  font-size: 12px;
  padding: 10px !important;
}
</style>